module.exports = __webpack_public_path__ + "img/classic_season20_6.24f0d354.jpg";